import { Reducer } from 'react';
import Prompts from '.';
import { getInitialState } from './PromptsContext';

const reducer: Reducer<Prompts.ContextState, Prompts.ContextActions> = (
  state,
  action
) => {
  switch (action.type) {
    case 'OpenSwitchAvatarVersionPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenImportScriptPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenImportCsvPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenSplitScriptPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenUpgradePlanPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenUpsellPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenCommentsUpsellPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenAPIRequestKeyPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenCancelSubscriptionPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenUndoCancelSubscriptionPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenSubscriptionPaymentPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenSubscriptionTiersPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenProjectDeletionPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenProjectSettingsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenProjectSharingPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenProjectSharingTeamMemberBulkEditPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenProjectAccessDestructiveActionPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenMoveClipsToProjectPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenBatchDeleteClipsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDeleteClipPreviewPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenPhoneticLibraryImportPrompt':
      return {
        activePrompt: action.type,
      };
    case 'OpenCombineClipsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberEditPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberInvitationPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberMaxSeatsReachedPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberAdjustSeatPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberInvitationCancellationPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberInvitationUpdatePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberRemovalPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamMemberRemovalPromptV2':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamRequestSeatsPrompt':
      return {
        activePrompt: action.type,
      };
    case 'OpenAvatarModalPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenEntityChangedNotificationPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenFilterAvatarsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenCopyClipsToProjectPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenReplacementsMigrationPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenReplacementsLibraryPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenProjectReplacementsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenConfirmationPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenUnfavoriteAvatarsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenRemoveTeamVoicePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenVoiceUpgradePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenFolderCreatePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenFolderDeletePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDriveMovePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDriveCreatePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenWorkspaceEditSettingsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenFolderRenamePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenWorkspaceMemberAccessPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenWorkspaceDeletePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenEntitlementLapsePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDownloadPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenCombineDownloadErrorPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenWorkspaceBulkDeletePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDeleteClipCommentConfirmationPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenWorkspaceMemberAccessWarningPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTeamSeatTypeChangePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTakeHistoryPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDeleteSectionsPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenBulkGenerateLimitPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenTranslatePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenUpdateDefaultPausePrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenNonEnglishTranslationWarningPrompt':
      return {
        activePrompt: action.type,
      };
    case 'OpenPurchaseAddOnPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenCancelAddOnPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenDownloadLimitReachedPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'OpenAudioFeedbackPrompt':
      return {
        activePrompt: action.type,
        activePromptPayload: action.payload,
      };
    case 'CloseActivePrompt':
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return getInitialState();
    default:
      return state;
  }
};

export default reducer;
